import { request } from '../utils/request';
import qs from 'qs';

// 获取列表数据
export async function getListData(current,pagesize) {
  return request(`/project/selectAll?${qs.stringify({pageNum: current,pageSize:pagesize,k:(new Date()).getTime()})}`);
}
// 枚举
export async function enumerationData() {
  return request('/project/selectDictMaps');
}
// 列表提交
export async function listSubmitData(key) {
  let api =`/project/commitByList?p_csrf=${window.GLOBAL_CONFIG.csrf_val}`,
    id = {id:key};
  return request( api, {
    method:'POST',
    body:qs.stringify(id)
  });
}
//园区列表页根据城市名查询园区信息列表
export async function getParkList(city) {
  return request(`/api/incubator/queryParkBaseInfoByCity?${qs.stringify({city: city})}`);
}
// 园区详情获取
export async function queryParkInfo(city) {
  return request(`/api/incubator/detail/${city}`);
}

// 申请页权限
export async function checkUserApply() {
  return request('/api/incubator/checkUserApply');
}

// 申请页手机号是否填写
export async function checkUserIsHavePhone() {
  return request('/api/incubator/checkUserIsHavePhone');
}

// 园区入驻
export async function parkApply(msg) {
  let api =`/api/incubator/parkApply?p_csrf=${window.GLOBAL_CONFIG.csrf_val}`;
  return request( api, {
    method:'POST',
    body:qs.stringify(msg)
  });
}

//获取用户项目列表
export async function getUserAllProject() {
  return request('/api/incubator/getUserAllProject');
}

//根据用户所选项目获取基本数据
export async function selectBaseOne(projectId) {
  return request(`/project/selectBaseOne?${qs.stringify({projectId:projectId})}`);
}

//行业领域
export async function domains() {
  return request('/dict/domains');
}

// 行业子领域
export async function subdomains(domain) {
  return request(`/dict/subdomains?${qs.stringify({domainCode: domain})}`);
}

//省
export async function provinces() {
  return request('/dict/provinces');
}

//市
export async function cities(provinceCode) {
  return request(`/dict/cities?${qs.stringify({provinceCode:provinceCode})}`);
}

// 添加园区
export async function addParkInfo(data) {
  let api =`/parkAdmin/addParkInfo?p_csrf=${window.GLOBAL_CONFIG.csrf_val}`;
  return request( api, {
    method:'POST',
    body:qs.stringify(data)
  });
}

//申请园区列表
export async function parkApplyList(data) {
  let api =`/api/incubator/manage/parkApplyList?p_csrf=${window.GLOBAL_CONFIG.csrf_val}`;
  return request( api, {
    method:'POST',
    body:qs.stringify(data)
  });
}

//申请园区列表审核
export async function auditApply(data) {
  let api =`/api/incubator/manage/auditApply?p_csrf=${window.GLOBAL_CONFIG.csrf_val}`;
  return request( api, {
    method:'POST',
    body:qs.stringify(data)
  });
}

//园区入驻列表
export async function parkEnterList(data) {
  return request(`/api/incubator/manage/parkEnter/list?${qs.stringify(data)}`);
}

//入驻企业-企业入驻
export async function parkEnterEnter(id) {
  let api =`/api/incubator/manage/parkEnter/enter?p_csrf=${window.GLOBAL_CONFIG.csrf_val}`;
  return request( api, {
    method:'POST',
    body:qs.stringify({enterRecordId:id})
  });
}

//入驻企业-企业搬离
export async function parkEnterLeave(id) {
  let api =`/api/incubator/manage/parkEnter/leave?p_csrf=${window.GLOBAL_CONFIG.csrf_val}`;
  return request( api, {
    method:'POST',
    body:qs.stringify({enterRecordId:id})
  });
}

//添加入驻项目
export async function submitProject(data) {
  let api =`/api/incubator/manage/parkEnter/submitProject?p_csrf=${window.GLOBAL_CONFIG.csrf_val}`;
  return request( api, {
    method:'POST',
    body:qs.stringify(data)
  });
}

//添加入驻项目-根据用户名查询pk
export async function searchAliyunPK(values) {
  return request(`/api/incubator/manage/parkEnter/judgeUserAccountIsExist?${qs.stringify(values)}`);
}

// 查询园区信息(后台)
export async function getParkInfo(globalParkId) {
  return request(`/api/incubator/manage/detail/${globalParkId}`);
}

//园区管理信息更新
export async function updateParkInfo(data) {
  let api =`/api/incubator/manage/updateParkInfo?p_csrf=${window.GLOBAL_CONFIG.csrf_val}`;
  return request( api, {
    method:'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body:JSON.stringify(data)
  });
}

// 园区官网所属列表
export async function getAllParkIdAndName(parkId) {
  return request(`/api/incubator/getAllParkIdAndName?${qs.stringify({parkId:parkId})}`);
}

//domains
export async function queryParkFromCity() {
  return request('/api/incubator/queryParkFromCity');
}

// 项目名称重复
export async function getProjectTitleData(name) {
  if(name && name!==''){
    return request(`/project/judgeProName?${qs.stringify({projectTitle:name})}`);
  }
  
}
//申请园区后台提示
export async function getUserLatestApplyAndEnterRecord() {
  return request('/api/incubator/getUserLatestApplyAndEnterRecord');
}

//家居大赛活动报名
export async function eventApply(values) {
  let api =`/api/event/eventApply?p_csrf=${window.GLOBAL_CONFIG.csrf_val}`;
  return request( api, {
    method:'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body:JSON.stringify(values)
  });
}

//活动报名申请表
export async function eventSubmitProject(values) {
  let api =`/api/event/manage/submitProject?p_csrf=${window.GLOBAL_CONFIG.csrf_val}`;
  return request( api, {
    method:'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body:JSON.stringify(values)
  });
}

//所需融资轮次查询
export async function eventApplyList(values) {
  let api =`/api/event/manage/eventApplyList?p_csrf=${window.GLOBAL_CONFIG.csrf_val}`;
  return request( api, {
    method:'POST',
    body:qs.stringify(values)
  });
}


// WEBPACK FOOTER //
// ./src/scripts/services/incubator.js